import format from 'date-fns/format';
//import { axios } from './../../api';

export default {
	props: {
		loadOnStart: {
			type: Boolean,
			default: true,
		},
		mineOnly: {
			type: Boolean,
			default: false,
		},
		newOnly: {
			type: Boolean,
			default: false,
		},
		pendingOnly: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			error: false,
			loading: false,
			loaded: false,
			empty: false,
			fields: []
		};
	},
	computed: {
		css() {
			return {
				tableClass: this.loading ? 'table table--loading' : 'table',
				ascendingIcon: 'sort sort--asc',
				descendingIcon: 'sort sort--desc',
				handleIcon: '',
				renderIcon: function(classes, options) {
					if(classes[0] === 'sort-icon' && classes[1]) {
						return `<svg class="svg-icon ${ classes.join(' ') }">
							<use xlink:href="#icon--sort"></use>
						</svg>`;
					}

					return '';
				}
			};
		},
	},
	methods: {
		formatDate: value => value ? format(value, 'DD/MM/YY') : 'Never',
		onPaginationData(paginationData) {
			this.$refs.pagination.setPaginationData(paginationData)
		},
		onChangePage(page) {
			this.$refs.vuetable.changePage(page)
		},
		onRowClass(dataItem, index) {
			if(dataItem.status === 0) {
				return 'draft';
			}

			if(dataItem.status === 1) {
				return 'pending';
			}
		},
		onLoading() {},
		onLoaded() {
			if(this.$refs.vuetable.displayEmptyDataRow) {
				this.empty = true;
			}
		},
		onLoadError() {},
		fetch(apiUrl, httpOptions) {
			this.error = false;
			this.loaded = false;
			this.loading = true;
			this.empty = false;

			if(this.mineOnly) {
				apiUrl = `${apiUrl}/mine`
			}

			if(this.newOnly) {
				apiUrl = `${apiUrl}/new`;
			}

			if(this.pendingOnly) {
				apiUrl = `${apiUrl}/pending`;
			}

			return axios.get(apiUrl, httpOptions)
				.then((response) => {
					this.loaded = true;

					if(response.data && Array.isArray(response.data.data) && !response.data.data.length) {
						this.empty = true;
					}

					return response;
				})
				.catch(() => {
					this.error = true;
					this.$refs.vuetable.resetData();
				})
				.finally(() => {
					this.loading = false;
				});
		},
		load(force) {
			if(!force && (this.loaded || this.loading)) {
				return;
			}

			this.$refs.vuetable.reload();
		}
	}
}
